import { usd, usd2, pctFrac, mult } from "@/lib/format";
import { Stat } from "@/components/common/Ornament";

export default function KpiGrid({ r }) {
  return (
    <div className="space-y-4" data-testid="calc-outputs">
      <div className="grid grid-cols-2 xl:grid-cols-4 gap-3">
        <Stat dark label="Levered IRR" value={pctFrac(r.leveredIRR)} sub={`${r.hold}-yr hold`} testId="output-levered-irr" />
        <Stat dark label="Unlevered IRR" value={pctFrac(r.unleveredIRR)} testId="output-unlevered-irr" />
        <Stat dark label="Equity Multiple" value={mult(r.equityMultiple)} testId="output-equity-multiple" />
        <Stat dark label="Cash-on-Cash (Y1)" value={pctFrac(r.coc1)} sub={`Avg ${pctFrac(r.avgCoc)}`} testId="output-coc" />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3">
        <Stat label="Total Project Cost" value={usd(r.totalCost)} testId="output-total-cost" />
        <Stat label="Cost per Key" value={usd(r.costPerKey)} testId="output-cost-per-key" />
        <Stat label="Loan / Equity" value={usd(r.loan)} sub={`Equity ${usd(r.equity)}`} testId="output-loan" />
        <Stat label="RevPAR (Y1)" value={usd2(r.revpar1)} testId="output-revpar" />
        <Stat label="Total Revenue (Y1)" value={usd(r.totalRev1)} testId="output-total-revenue" />
        <Stat label="NOI (Y1)" value={usd(r.noi1)} testId="output-noi" />
        <Stat label="DSCR (Y1)" value={r.dscr1 ? `${r.dscr1.toFixed(2)}x` : "—"} sub={r.minDscr ? `Min ${r.minDscr.toFixed(2)}x` : ""} testId="output-dscr" />
        <Stat label="CF After Debt (Y1)" value={usd(r.years[0].cfAfter)} sub={`Before debt ${usd(r.years[0].noi)}`} testId="output-cf-after" />
        <Stat label="Projected Exit Value" value={usd(r.exitValue)} sub={`Net of costs ${usd(r.netSale)}`} testId="output-exit-value" />
        <Stat label="Exit Value per Key" value={usd(r.exitPerKey)} testId="output-exit-per-key" />
        <Stat label="Loan Payoff at Exit" value={usd(r.payoff)} testId="output-payoff" />
        <Stat label="Forward NOI (Exit)" value={usd(r.forwardNoi)} sub={`Year ${r.hold + 1}`} testId="output-forward-noi" />
        <Stat label="Yield on Cost" value={pctFrac(r.yieldOnCost)} sub={`Stabilized NOI (Y${r.stabYear}) ÷ cost`} testId="output-yield-on-cost" />
        <Stat label="Development Spread" value={r.devSpread === null ? "—" : `${(r.devSpread * 10000).toFixed(0)} bps`} sub="Yield on cost − exit cap" testId="output-dev-spread" />
      </div>
    </div>
  );
}
